import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { useOutletContext } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';

import styles from './Home.styles';
import CenteredLoader from '../../../../components/loaders/PageLoader';

import HomeBarChart from '../../components/Home/HomeBarChart';
import HomePieChart from '../../components/Home/HomePieChart';
import HomeTable from '../../components/Home/HomeTable';

import { useHomeData } from '../../hooks/useHomeData';
import useAuthUser from '../../../auth/hooks/useAuthUser';
import { useCrumb } from '../../../../layouts/TrailProvider';

export default function Home() {
  const { isSidebarExpanded } = useOutletContext();
  useCrumb('Home', '/home');

  const { loading: userLoading, user } = useAuthUser();
  const {
    fileStats = null,
    operatorStats = [],
    fileFailures = [],
    loading,
  } = useHomeData();

  const nickname = useMemo(() => {
    const name = user?.name?.trim();
    if (name) {
      const comma = name.indexOf(',');
      if (comma !== -1) {
        const after = name.slice(comma + 1).trim();
        if (after) return after.split(/\s+/)[0];
      }
      const first = name.split(/\s+/)[0];
      if (first) return first;
    }
    const email = user?.email;
    if (email && typeof email === 'string' && email.includes('@')) {
      const local = email.split('@')[0];
      const firstFromLocal = local.split(/[._-]/)[0];
      return firstFromLocal
        ? firstFromLocal.charAt(0).toUpperCase() + firstFromLocal.slice(1)
        : local;
    }
    return '';
  }, [user]);

  const isReady =
    !!fileStats && operatorStats != null && Array.isArray(fileFailures);

  return (
    <Box
      sx={{
        ...styles.homeContent,
        marginLeft: isSidebarExpanded ? '240px' : '95px',
        width: isSidebarExpanded
          ? 'calc(100vw - 240px)'
          : 'calc(100vw - 95px)',
        transition: 'all 0.3s ease',
      }}
    >
      {loading || userLoading || !isReady ? (
        <CenteredLoader />
      ) : (
        <>
          <Box sx={styles.headerRow}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <HomeIcon
                sx={{ ...styles.welcomeMessage, mr: 1 }}
                aria-hidden
              />
              <Typography sx={styles.welcomeMessage}>
                {nickname
                  ? `Welcome back, ${nickname}`
                  : 'Welcome back'}
              </Typography>
            </Box>
          </Box>

          <Box sx={styles.innerCardContainer}>
            <HomeBarChart operatorStats={operatorStats || []} />
            <HomePieChart fileStats={fileStats} />

            <HomeTable sortedFailures={fileFailures} />
          </Box>
        </>
      )}
    </Box>
  );
}
